import { HttpClient } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import {
  Flat_Create,
  Flat_Update,
  Flat_Delete,
  Flat_ReadAll,
  Flat_ReadByUserId,
  Flat_ReadByBuildingId,
  Flat_ReadByBuildingId_External,
  Flat_ReadById,
  Flat_CreateBulk,
  Flat_GetFlatsCountBySocietyId,
  Flat_ReadByOwnerId
} from 'src/app/GlobalVariable';
import { HttpHeaders } from '@angular/common/http';
import {
  FlatCreateRequestDTO,
  FlatDTO,
  FlatUpdateRequestDTO,
  FlatDeleteRequestDTO,
  FlatReadByBuildingIdRequestDTO,
  FlatList,
  FlatReadByIdRequestDTO,
  FlatMasterCreateBulkRequestDTO,
  GetFlatCountBySocietyIdRequestDTO,
  GetFlatsCountBySocietyIdResponseDTO,
  FlatReadByOwnerIdRequestDTO
} from './flat.interface';


@Injectable({
  providedIn: 'root',
})
export class FlatService {

  private http = inject(HttpClient);

  Flat_Create(data: FlatCreateRequestDTO): Observable<FlatDTO> {
    return this.http.post<FlatDTO>(Flat_Create, data);
  }

  Flat_Update(data: FlatUpdateRequestDTO): Observable<FlatDTO> {
    return this.http.post<FlatDTO>(Flat_Update, data);
  }

  Flat_Delete(data: FlatDeleteRequestDTO): Observable<void> {
    return this.http.post<void>(Flat_Delete, data);
  }

  Flat_ReadAll(): Observable<FlatList> {
    return this.http.get<FlatList>(Flat_ReadAll);
  }

  Flat_ReadByBuildingId(data: FlatReadByBuildingIdRequestDTO): Observable<FlatList> {
    return this.http.post<FlatList>(Flat_ReadByBuildingId, data);
  }

  Flat_ReadByBuildingId_External(
    data: FlatReadByBuildingIdRequestDTO,
    xApiKey?: string,
    xApiTimestamp?: string,
    xApiNonce?: string,
    xApiSignature?: string
  ): Observable<FlatList> {
    let headers = new HttpHeaders({ 'Content-Type': 'application/json' });
    if (xApiKey && xApiSignature) {
      headers = headers
        .set('X-Api-Key', xApiKey)
        .set('X-Api-Timestamp', xApiTimestamp || '')
        .set('X-Api-Nonce', xApiNonce || '')
        .set('X-Api-Signature', xApiSignature);
    }
    return this.http.post<FlatList>(Flat_ReadByBuildingId_External, data, { headers });
  }

  Flat_ReadByOwnerId(data: FlatReadByOwnerIdRequestDTO): Observable<FlatList> {
    return this.http.post<FlatList>(Flat_ReadByOwnerId, data);
  }

  Flat_ReadById(data: FlatReadByIdRequestDTO): Observable<FlatDTO> {
    return this.http.post<FlatDTO>(Flat_ReadById, data);
  }


  Flat_CreateBulk(data: FlatMasterCreateBulkRequestDTO): Observable<FlatList> {
    return this.http.post<FlatList>(Flat_CreateBulk, data);
  }

  Flat_GetFlatsCountBySocietyId(data: GetFlatCountBySocietyIdRequestDTO): Observable<GetFlatsCountBySocietyIdResponseDTO> {
    return this.http.post<GetFlatsCountBySocietyIdResponseDTO>(Flat_GetFlatsCountBySocietyId, data);
  }
  
}
